import moment from "moment";
import {TOKEN_NAME} from "./constants/storage";
import {store} from "../../store/store";

export const getUrlWithFiltersOrdini = (integrationId, sort, page, rowsPerPage, filter) => {
    let query = `?integrationId=${integrationId}&sort=${sort}&page=${page}&size=${rowsPerPage}`;
    Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key] !== null) {
            if (key.includes("date")) {
                let date = moment.utc(filter[key]).local().format("YYYY-MM-DD");
                if (key.toLowerCase().includes("lt")) {
                    date = moment.utc(filter[key]).add(1, 'd').local().format("YYYY-MM-DD")
                }
                query = query.concat(`&${key}=${date}`);
            } else {
                query = query.concat(`&${key}=${filter[key]}`);
            }

        }
    });
    return query;
}

export const getUrlWithFilters = (sort, page, rowsPerPage, integrationId = "", filter, allRows = false) => {
    if (allRows) {
        return `?sort=${sort}&integrationId=${integrationId}`;
    }
    let filterJoined = `?sort=${sort}&page=${page}&size=${rowsPerPage}&integrationId=${integrationId}`;
    Object.keys(filter).forEach(key => {
        if (filter[key].value) {
            if(key==="listaDiNumeri"){
                return;
            }
            if (Array.isArray(filter[key].value)) {
                if (filter[key].value.length !== 0) {
                    let joined
                    if (filter[key].value[0].label) {
                        if (key === 'tags') {
                            joined = filter[key].value.map(f => f.label).join(",");
                        } else {
                            joined = filter[key].value.map(f => f.id).join(",");
                        }
                    } else {
                        joined = filter[key].value.join(",");
                    }
                    filterJoined = filterJoined.concat(`&${key}=${joined}`);
                }
            } else {
                if (filter[key].value !== "") {
                    filterJoined = filterJoined.concat(`&${key}=${filter[key].value}`)
                }
            }
        } else if (filter[key].name) {
            if (filter[key].from) {
                let from = moment.utc(filter[key].from).local().format("YYYY-MM-DD");
                filterJoined = filterJoined.concat(`&${key}From=${from}`);
            }
            if (filter[key].to) {
                let to = moment.utc(filter[key].to).add(1, 'd').local().format("YYYY-MM-DD");
                filterJoined = filterJoined.concat(`&${key}To=${to}`);
            }
        }
    })
    return filterJoined;
}

export const encodeData = (query) => {
    return query.replace(/\+/g, '%2B');
}

export const samlLogout = () => {
    if (sessionStorage.getItem(TOKEN_NAME)) {
        sessionStorage.removeItem(TOKEN_NAME);
    }
    if (window.location.hostname === "localhost") {
        window.location.replace(`https://localhost:8080/saml/logout?redirect_uri=https://localhost`)
    } else {
        window.location.replace(`https://${window.location.hostname}:8443/saml/logout?redirect_uri=https://${window.location.hostname}`)
    }
};

let timer = 0;

export const handleUnauthorizedError = (error) => {
    if (timer) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
            if (error?.response?.status === 401) {
                if (store.getState().authReducer.token !== "") {
                    samlLogout();
                } else {
                    window.location.replace(`https://${window.location.hostname}:8443/saml/login`);
                }
            }
        }, 1000
    )

}
